import { createSelector } from '@reduxjs/toolkit';
import { EFacilityType, FDealType } from '../../../../packages/JsonQuery';
import { selectDealType } from 'shared/selectors/jsonQuery';

const SUBURBAN_FACILITIES = [
  { label: 'Неважно', value: null },
  { label: 'Баня', value: EFacilityType.Sauna },
  { label: 'Гараж', value: EFacilityType.Garage },
  { label: 'Бассейн', value: EFacilityType.Pool },
];

const SALE_SUBURBAN_FACILITIES = [
  { label: 'Баня', value: EFacilityType.Sauna },
  { label: 'Гараж', value: EFacilityType.Garage },
  { label: 'Охрана', value: EFacilityType.Security },
  { label: 'Бассейн', value: EFacilityType.Pool },
];

export const selectSuburbanFacilitiesOptions = createSelector(selectDealType, dealType => {
  if (dealType === FDealType.Sale) {
    return SALE_SUBURBAN_FACILITIES;
  }

  return SUBURBAN_FACILITIES;
});
